<mat-card-header>
    <h1>BoardingTime</h1>
</mat-card-header>
<mat-card-content>
    <app-grid-list [data]="gridData_1" [isEditable]="isEditable"></app-grid-list>
</mat-card-content>
<mat-card-header>
    <h1>DeboardingTime</h1>
</mat-card-header>
<mat-card-content>
    <app-grid-list [data]="gridData_2" [isEditable]="isEditable"></app-grid-list>
</mat-card-content>